import { useTranslation } from "react-i18next";

/**
 * DisclaimerSection - 免责声明区域
 * 显示在首页底部，Footer上方
 * 解释星号标记的含义
 */
export function DisclaimerSection() {
  const { t } = useTranslation("home");

  return (
    <section className="py-6 sm:py-8 bg-zinc-950 dark:bg-black">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-xs text-white/40 leading-relaxed">
          {t("disclaimer.starExplanation")}
        </p>
      </div>
    </section>
  );
}

export default DisclaimerSection;
